// // import React, { useState } from 'react';
// // import Breadcrumb from '@components/Shared/Breadcrumb';
// // import { Card, CardBody } from '@components/card/card';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import Select from 'react-select';
// // import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';
// // import useGetJournalsList from '@hooks/Finance/Journals/useGetJournalsList';
// // import NtxTable from '@components/DataTable/NtxTable';
// // import Loading from '@components/Shared/Loader/Loading';

// // const Index = () => {
// //   const [selectedLedger, setSelectedLedger] = useState<any>(null);
// //   const [search, setSearch] = useState('');
// //   const { t, i18n } = useTranslation();
// //   const { OptionsLedgers, loading, error } = useGetGlLedgersList();
// //   const { JournalsList } = useGetJournalsList();

// //   const filteredSearch = JournalsList?.slice()
// //     ?.filter((item) => {
// //       const searchLowerCase = search.toLowerCase();
// //       return item.name2?.toLowerCase().includes(searchLowerCase);
// //     })
// //     ?.filter((f) => (selectedLedger === null ? true : f.ledgerId === selectedLedger));

// //   const columns = [
// //     { title: 'رقم القيـد', key: 'no' },
// //     { title: 'التاريـخ', key: 'date' },
// //     // { title: 'المصدر', key: 'source' },
// //     { title: 'التصنيف', key: 'catogory' },
// //     { title: 'البيان', key: 'name' },
// //     { title: 'حالة القيد', key: 'status' },
// //     { title: 'دائن', key: 'Cr' },
// //     { title: 'مديـن', key: 'Dr' },
// //     { title: '', key: 'action', className: 'text-end', sortable: false },
// //   ];

// //   const tableData = filteredSearch?.map((item, idx) => {
// //     let rowClass;

// //     // تحديد الشارة بناءً على قيمة `status`
// //     const statusBadge = () => {
// //       switch (item.status) {
// //         case 'U':
// //           return (
// //             <span className="badge bg-danger ">
// //               <i className="fas fa-times-circle me-1"></i> قيد غير مرحل
// //             </span>
// //           );
// //         case 'T':
// //           return (
// //             <span className="badge bg-warning ">
// //               <i className="fas fa-clock me-1"></i> حفظ مؤقت
// //             </span>
// //           );
// //         case 'P':
// //           return (
// //             <span className="badge bg-success ">
// //               <i className="fas fa-check-circle me-1"></i> قيد مرحل
// //             </span>
// //           );
// //         default:
// //           return '.';
// //         // return <span className="badge bg-secondary">غير معروف</span>;
// //       }
// //     };

// //     return {
// //       no: ++idx,
// //       date: item.glDate,
// //       source: i18n.language === 'en' ? item.jeSourceName : item.jeSourceName2,
// //       catogory: i18n.language === 'en' ? item.jeCategoryName : item.jeCategoryName2,
// //       name: i18n.language === 'en' ? item.name : item.name2,
// //       Cr: item.enteredCr,
// //        Dr: item.enteredDr,
// //       status: statusBadge(),
// //       action: (
// //         <Link to={`${item.id}/UpdateJournals`} className="btn btn-sm btn-outline-theme mx-2">
// //           <i className="fas fa-lg fa-fw fa-edit"></i>
// //           {/* عرض تفاصيل القيد */}
// //         </Link>
// //       ),
// //     };
// //   });

// //   //____________________________

// //   return (
// //     <div>
// //       <div className="d-flex align-items-center">
// //         <Breadcrumb
// //           BreadcrumbList={[
// //             {
// //               name: 'Home',
// //               link: ':moduleHome',
// //             },
// //             {
// //               name: 'القيود المالية',
// //               link: null,
// //             },
// //           ]}
// //           PageName="القيود المالية"
// //         />
// //       </div>

// //       <Card>
// //         <Loading loading={loading} error={error}>
// //           <CardBody>
// //             <div className="row mb-1">
// //               <div className="col-lg-4">
// //                 <div className="input-group flex-nowrap">
// //                   <span className="input-group-text fw-bold">{t('Search')}</span>
// //                   <div className="input-group">
// //                     <div className="flex-fill position-relative">
// //                       <div className="input-group border-0 ">
// //                         <div
// //                           className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
// //                            >
// //                           <i className="fa fa-search opacity-5 text-theme"></i>
// //                         </div>
// //                         <input
// //                           type="text"
// //                           autoComplete="off"
// //                           className="form-control ps-35px"
// //                           // placeholder={t('Search')}
// //                           value={search}
// //                           onChange={(e) => {
// //                             setSearch(e.target.value);
// //                           }}
// //                         />
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>

// //               <div className={selectedLedger ? 'col-lg-6' : 'col-lg-8'}>
// //                 <div className="input-group flex-nowrap">
// //                   <span className="input-group-text  fw-bold">{t('الأستاذ العام')}</span>
// //                   <Select
// //                     classNamePrefix="react-select"
// //                     className="w-100"
// //                     isLoading={loading}
// //                     value={OptionsLedgers.find((f) => f.value === selectedLedger) || null}
// //                     isSearchable={true}
// //                     isClearable
// //                     options={[
// //                       {
// //                         value: '',
// //                         // value: null,
// //                         label: t('All'),
// //                         currencyCode: '',
// //                       },
// //                       ...OptionsLedgers,
// //                     ]}
// //                     onChange={(option) => setSelectedLedger(option === null ? null : option.value)}
// //                     placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
// //                     formatOptionLabel={(option) => (
// //                       <div className="d-flex justify-content-between">
// //                         <div className="">{option.label}</div>
// //                         <div className="text-theme fw-bold">{option.currencyCode}</div>
// //                       </div>
// //                     )}
// //                   />
// //                 </div>
// //               </div>

// //               <div className="col-lg-2 text-end">
// //                 {selectedLedger && (
// //                   <Link to={`${selectedLedger}/AddJournals`} className="btn btn-theme   rounded-0">
// //                     <i className="fa fa-plus-circle fa-fw me-1 p-1"></i>
// //                     {t('إضافة قيـــد')}
// //                   </Link>
// //                 )}
// //               </div>
// //             </div>

// //             <NtxTable
// //               data={tableData || []}
// //               columns={columns}
// //               dataPerPage={10}
// //               theadClass=""
// //               tableClass="table text-nowrap table-hover "
// //             />
// //           </CardBody>
// //         </Loading>
// //       </Card>
// //     </div>
// //   );
// // };

// // export default Index;

// import { useEffect, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getPagedData, setEndpoint, setFilters } from '@store/DynamicFilter/dynamicTableSlice';
// import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
// import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
// import Select from 'react-select';
// // import useGetJeCategories from '@hooks/Finance/useGetJeCategories';
// // import useGetJeSources from '@hooks/Finance/useGetJeSources';
// // import useGetPeriods from '@hooks/Finance/useGetPeriods';

// const TABLE_KEY = 'GlJeHeaders_Index';

// const Index = () => {
//   const { t, i18n } = useTranslation();

//   // ✅ حالة الفلاتر المحلية
//   const [ledgerFilter, setLedgerFilter] = useState<any>(null);
//   const [categoryFilter, setCategoryFilter] = useState<any>(null);
//   const [sourceFilter, setSourceFilter] = useState<any>(null);
//   const [periodFilter, setPeriodFilter] = useState<any>(null);
//   const [statusFilter, setStatusFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [codeFilter, setCodeFilter] = useState('');

//   const [showFilters, setShowFilters] = useState(false);

//   // ✅ Hooks لجلب البيانات المرجعية
//   // const { ledgersOptions } = useGetLedgers();
//   // const { jeCategoriesOptions } = useGetJeCategories();
//   // const { jeSourcesOptions } = useGetJeSources();
//   // const { periodsOptions } = useGetPeriods();

//   const dispatch = useAppDispatch();
//   const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
//   const data = tableState?.data ?? [];
//   const loading = tableState?.loading ?? false;
//   const error = tableState?.error ?? null;
//   const filters = tableState?.filters ?? [];
//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   // ✅ تهيئة الجدول
//   useEffect(() => {
//     dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Finance/GetGlJeHeadersList_Paged' }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   }, [dispatch]);

//   // ✅ حساب عدد الفلاتر النشطة
//   useEffect(() => {
//     setActiveFiltersCount(filters.length);
//   }, [filters]);

//   // ✅ دالة إنشاء ID فريد للفلتر
//   const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//   // ✅ دالة تطبيق الفلاتر
//   const applyFilters = () => {
//     const newFilters: any[] = [];

//     if (ledgerFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'ledgerId',
//         operator: 0,
//         value: ledgerFilter.value
//       });
//     }

//     if (categoryFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'jeCategory',
//         operator: 0,
//         value: categoryFilter.value
//       });
//     }

//     if (sourceFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'jeSource',
//         operator: 0,
//         value: sourceFilter.value
//       });
//     }

//     if (periodFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'periodId',
//         operator: 0,
//         value: periodFilter.value
//       });
//     }

//     if (statusFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'status',
//         operator: 0,
//         value: statusFilter.value
//       });
//     }

//     if (codeFilter.trim()) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'code',
//         operator: 6, // Contains
//         value: codeFilter.trim()
//       });
//     }

//     if (dateFrom) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'glDate',
//         operator: 3, // GreaterThanOrEqual
//         value: dateFrom
//       });
//     }

//     if (dateTo) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'glDate',
//         operator: 5, // LessThanOrEqual
//         value: dateTo
//       });
//     }

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ دالة مسح جميع الفلاتر
//   const clearFilters = (): void => {
//     setLedgerFilter(null);
//     setCategoryFilter(null);
//     setSourceFilter(null);
//     setPeriodFilter(null);
//     setStatusFilter(null);
//     setCodeFilter('');
//     setDateFrom('');
//     setDateTo('');

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ خيارات حالة القيد
//   const statusOptions = [
//     { value: 'P', label: t('مرحل') },
//     { value: 'U', label: t('غير مرحل') },
//     { value: 'F', label: t('نهائي') },
//     { value: 'I', label: t('قيد المعالجة') }
//   ];

//   // ✅ حقول Dynamic Filter
//   const fields: any = [
//     { name: 'code', label: t('رقم القيد'), type: 'string' },
//     { name: 'name', label: t('الاسم'), type: 'string' },
//     { name: 'name2', label: t('الاسم (En)'), type: 'string' },
//     { name: 'glDate', label: t('تاريخ القيد'), type: 'date' },
//     { name: 'postedDate', label: t('تاريخ الترحيل'), type: 'date' },
//     {
//       name: 'status',
//       label: t('الحالة'),
//       type: 'options',
//       options: statusOptions
//     },

//     {
//       name: 'jeCategory',
//       label: t('فئة القيد'),
//       type: 'options',
//       options: []
//     },
//     {
//       name: 'jeSource',
//       label: t('مصدر القيد'),
//       type: 'options',
//       options: []
//     },
//     {
//       name: 'periodId',
//       label: t('الفترة'),
//       type: 'options',
//       options: []
//     },
//     { name: 'description', label: t('الوصف'), type: 'string' },
//     { name: 'enteredDr', label: t('مدخل مدين'), type: 'number' },
//     { name: 'enteredCr', label: t('مدخل دائن'), type: 'number' },
//     { name: 'accountedDr', label: t('محاسب مدين'), type: 'number' },
//     { name: 'accountedCr', label: t('محاسب دائن'), type: 'number' }
//   ];

//   // ✅ دالة لتنسيق المبلغ
//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   // ✅ دالة لعرض الحالة مع أيقونة
//   const getStatusBadge = (status: string) => {
//     switch (status) {
//       case 'P': // Posted
//         return (
//           <span className='badge bg-success' title={t('مرحل')}>
//             <i className='fas fa-check-circle me-1'></i>
//             مرحل
//           </span>
//         );
//       case 'U': // Unposted
//         return (
//           <span className='badge bg-warning text-dark' title={t('غير مرحل')}>
//             <i className='fas fa-clock me-1'></i>
//             غير مرحل
//           </span>
//         );
//       case 'F': // Final
//         return (
//           <span className='badge bg-primary' title={t('نهائي')}>
//             <i className='fas fa-lock me-1'></i>
//             نهائي
//           </span>
//         );
//       case 'I': // In Process
//         return (
//           <span className='badge bg-info text-dark' title={t('قيد المعالجة')}>
//             <i className='fas fa-cog me-1'></i>
//             قيد المعالجة
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-light text-dark' title={status || t('غير معروف')}>
//             <i className='fas fa-circle me-1'></i>
//             {status || 'غير معروف'}
//           </span>
//         );
//     }
//   };

//   // ✅ دالة لعرض رقم القيد مع التاريخ في عمود واحد
//   const renderCodeWithDate = (code: string, date: string, status: string) => {
//     const formattedDate = date.split('T')[0];
//     const isPosted = status === 'P';
//     const textClass = isPosted ? 'text-success' : 'text-theme';

//     return (
//       <div className='d-flex flex-column'>
//         <div className='fw-bold'>
//           <span className={textClass} style={{ letterSpacing: '0.05em' }}>
//             {code}
//           </span>
//           {isPosted && (
//             <span className='badge bg-success badge-sm ms-2'>
//               <i className='fas fa-check'></i>
//             </span>
//           )}
//         </div>
//         <small className='text-muted'>
//           <i className='fas fa-calendar-alt me-1'></i>
//           {formattedDate}
//         </small>
//       </div>
//     );
//   };

//   // ✅ دالة لعرض المدخل والمحاسب في عمود واحد
//   const renderAmounts = (
//     enteredDr: number,
//     enteredCr: number,
//     accountedDr: number,
//     accountedCr: number,
//     conversionFlag: boolean
//   ) => {
//     const hasConversion = conversionFlag;

//     return (
//       <div className='d-flex flex-column gap-2'>
//         {/* المدخل */}
//         <div className='d-flex justify-content-between'>
//           <span className='text-muted small'>مدين:</span>
//           <span className='fw-bold text-danger'>{formatAmount(enteredDr)}</span>
//         </div>
//         <div className='d-flex justify-content-between'>
//           <span className='text-muted small'>دائن:</span>
//           <span className='fw-bold text-success'>{formatAmount(enteredCr)}</span>
//         </div>

//         {/* خط فاصل إذا كان هناك تحويل عملة */}
//         {hasConversion && (
//           <>
//             <hr className='my-1' />
//             <div className='d-flex justify-content-between'>
//               <span className='text-muted small'>
//                 <i className='fas fa-exchange-alt me-1'></i> محاسب مدين:
//               </span>
//               <span className='fw-bold text-danger'>{formatAmount(accountedDr)}</span>
//             </div>
//             <div className='d-flex justify-content-between'>
//               <span className='text-muted small'>
//                 <i className='fas fa-exchange-alt me-1'></i> محاسب دائن:
//               </span>
//               <span className='fw-bold text-success'>{formatAmount(accountedCr)}</span>
//             </div>
//           </>
//         )}
//       </div>
//     );
//   };

//   // ✅ دالة لعرض تفاصيل القيد (اسم، دفتر، فئة، مصدر)
//   const renderEntryDetails = (
//     name: string,
//     ledgerName: string,
//     categoryName: string,
//     sourceName: string,
//     periodName: string
//   ) => {
//     const displayName = i18n.language === 'en' ? name : name;

//     return (
//       <div className='d-flex flex-column'>
//         <div className='fw-bold text-theme mb-1' title={displayName}>
//           {displayName && displayName.length > 60 ? `${displayName.substring(0, 60)}...` : displayName}
//         </div>
//         <div className='d-flex flex-wrap gap-2 mt-2'>
//           {ledgerName && (
//             <span className='badge bg-info bg-opacity-25 text-dark small'>
//               <i className='fas fa-book me-1'></i>
//               {ledgerName}
//             </span>
//           )}
//           {categoryName && (
//             <span className='badge bg-primary bg-opacity-25 text-dark small'>
//               <i className='fas fa-tag me-1'></i>
//               {categoryName}
//             </span>
//           )}
//           {sourceName && (
//             <span className='badge bg-success bg-opacity-25 text-dark small'>
//               <i className='fas fa-database me-1'></i>
//               {sourceName}
//             </span>
//           )}
//           {periodName && (
//             <span className='badge bg-warning bg-opacity-25 text-dark small'>
//               <i className='fas fa-calendar me-1'></i>
//               {periodName}
//             </span>
//           )}
//         </div>
//       </div>
//     );
//   };

//   // ✅ دالة للحصول على كلاسات الصف بناءً على حالة القيد
//   const getRowClasses = (status: string) => {
//     switch (status) {
//       case 'P': // Posted
//         return 'border-start border-3 border-success';
//       case 'U': // Unposted
//         return 'border-start border-3 border-warning';
//       case 'F': // Final
//         return 'border-start border-3 border-primary';
//       default:
//         return '';
//     }
//   };

//   const breadcrumbList = [
//     { name: t('Home'), link: ':moduleHome' },
//     { name: t('Finance'), link: null },
//     { name: t('JournalEntries'), link: null }
//   ];

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('JournalEntries')} />
//         <div className='ms-auto'>
//           <Link to='AddGlJeHeaders' className='btn btn-theme'>
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('NewJournalEntry')}
//           </Link>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* ✅ فلترة برقم القيد */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-hashtag'></i>
//                 </span>
//                 <input
//                   type='text'
//                   className='form-control'
//                   placeholder={t('رقم القيد')}
//                   value={codeFilter}
//                   onChange={e => setCodeFilter(e.target.value)}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بدفتر الأستاذ */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-book'></i>
//                 </span>
//                 <Select
//                   value={ledgerFilter}
//                   onChange={setLedgerFilter}
//                   options={[]}
//                   placeholder={t('دفتر الأستاذ')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالفئة */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-tag'></i>
//                 </span>
//                 <Select
//                   value={categoryFilter}
//                   onChange={setCategoryFilter}
//                   options={[]}
//                   placeholder={t('فئة القيد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالمصدر */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-database'></i>
//                 </span>
//                 <Select
//                   value={sourceFilter}
//                   onChange={setSourceFilter}
//                   options={[]}
//                   placeholder={t('مصدر القيد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالفترة */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-calendar'></i>
//                 </span>
//                 <Select
//                   value={periodFilter}
//                   onChange={setPeriodFilter}
//                   options={[]}
//                   placeholder={t('الفترة')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالحالة */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-info-circle'></i>
//                 </span>
//                 <Select
//                   value={statusFilter}
//                   onChange={setStatusFilter}
//                   options={statusOptions}
//                   placeholder={t('الحالة')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{
//                     menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ✅ التاريخ من وإلى */}
//             <div className='col-lg-6'>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                   placeholder={t('من')}
//                 />
//                 <span className='input-group-text'>-</span>
//                 <input
//                   type='date'
//                   className='form-control'
//                   value={dateTo}
//                   onChange={e => setDateTo(e.target.value)}
//                   placeholder={t('إلى')}
//                 />
//               </div>
//             </div>

//             {/* ✅ أزرار التطبيق والمسح */}
//             <div className='col-lg-3 text-end'>
//               <button
//                 className='btn btn-outline-secondary me-2'
//                 type='button'
//                 onClick={clearFilters}
//                 title={t('ClearFilters')}
//                 disabled={activeFiltersCount === 0}
//               >
//                 <i className='fas fa-times fa-fw'></i>
//               </button>
//               <button
//                 className='btn btn-theme me-2'
//                 type='button'
//                 onClick={applyFilters}
//                 title={t('ApplyFilters')}
//                 disabled={
//                   !ledgerFilter &&
//                   !categoryFilter &&
//                   !sourceFilter &&
//                   !periodFilter &&
//                   !statusFilter &&
//                   !codeFilter.trim() &&
//                   !dateFrom &&
//                   !dateTo
//                 }
//               >
//                 <i className='fas fa-filter fa-fw'></i>
//               </button>
//               <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
//                 <i className='fas fa-sliders-h fa-fw'></i>
//               </button>
//             </div>
//           </div>
//         </CardHeader>

//         <Loading loading={loading} error={error}>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='bg-theme bg-opacity-25 fw-bold'>
//                 <tr>
//                   <th className='small'>رقم القيد / التاريخ</th>
//                   <th className='small'>تفاصيل القيد</th>
//                   <th className='small'>المبالغ</th>
//                   <th className='small text-center'>الحالة</th>
//                   <th className='small text-center'>الإجراءات</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.length > 0 ? (
//                   data.map((item: any) => {
//                     const ledgerName = i18n.language === 'en' ? item.ledgerName : item.ledgerName2;
//                     const categoryName = i18n.language === 'en' ? item.jeCategoryName : item.jeCategoryName2;
//                     const sourceName = i18n.language === 'en' ? item.jeSourceName : item.jeSourceName2;
//                     const periodName = i18n.language === 'en' ? item.periodName : item.periodName2;

//                     return (
//                       <tr key={item.id} className={getRowClasses(item.status)}>
//                         <td className='align-middle'>{renderCodeWithDate(item.code, item.glDate, item.status)}</td>
//                         <td className='align-middle'>
//                           {renderEntryDetails(
//                             i18n.language === 'en' ? item.name : item.name2,
//                             ledgerName,
//                             categoryName,
//                             sourceName,
//                             periodName
//                           )}
//                         </td>
//                         <td className='align-middle'>
//                           {renderAmounts(
//                             item.enteredDr,
//                             item.enteredCr,
//                             item.accountedDr,
//                             item.accountedCr,
//                             item.conversionFlag
//                           )}
//                         </td>
//                         <td className='align-middle text-center'>{getStatusBadge(item.status)}</td>
//                         <td className='align-middle text-end'>
//                           <div className='d-flex justify-content-end gap-2'>
//                             <Link
//                               to={`${item.id}/UpdateGlJeHeaders`}
//                               className='btn btn-sm btn-outline-theme'
//                               title={t('ViewDetails')}
//                             >
//                               <i className='bi bi-info-circle fa-lg me-1'></i>
//                               تفاصيل
//                             </Link>
//                             <Link
//                               to={`${item.id}/GlJeLines`}
//                               className='btn btn-sm btn-outline-info'
//                               title={t('ViewLines')}
//                             >
//                               <i className='fas fa-list fa-lg me-1'></i>
//                               البنود
//                             </Link>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={5} className='text-center py-5 text-muted'>
//                       <div className='py-4'>
//                         <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
//                         <h5 className='mb-2'>
//                           {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoJournalEntries')}
//                         </h5>
//                         <p className='text-muted small'>
//                           {activeFiltersCount > 0
//                             ? 'جرب تغيير شروط البحث أو إزالة بعض الفلاتر'
//                             : 'لا توجد قيود يومية مسجلة في النظام'}
//                         </p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='text-theme'>
//             <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />
//     </>
//   );
// };

// export default Index;

import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
import Select from 'react-select';
import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';
import useGetGlJeCategoryList from '@hooks/Finance/useGetGlJeCategoryList';
import useGetGlJeSourceList from '@hooks/Finance/useGetGlJeSourceList';
import useGetGlPeriodsList from '@hooks/Finance/GlPeriods/useGetGlPeriodsList';

// ✅ عدّل هذه الهوكس حسب مشروعك
// import useGetLedgersList from '@hooks/Finance/GL/use-Get-LedgersList';
// import useGetJeCategoriesList from '@hooks/Finance/GL/use-Get-JeCategoriesList';
// import useGetJeSourcesList from '@hooks/Finance/GL/use-Get-JeSourcesList';
// import useGetPeriodsList from '@hooks/Finance/GL/use-Get-PeriodsList';

const TABLE_KEY = 'GlJeHeaders_Index';

const Index = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // ✅ state من dynamic table
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // ✅ فلاتر محلية أعلى الصفحة
  const [ledgerFilter, setLedgerFilter] = useState<any>(null);
  const [periodFilter, setPeriodFilter] = useState<any>(null);
  const [sourceFilter, setSourceFilter] = useState<any>(null);
  const [categoryFilter, setCategoryFilter] = useState<any>(null);
  const [statusFilter, setStatusFilter] = useState<any>(null);
  const [currencyFilter, setCurrencyFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // const { GlJeCategoryList, loading: loading2, error: error2 } = useGetGlJeCategoryList();
  // const { GlJeSourceList, loading: loading3, error: error3 } = useGetGlJeSourceList();
  // const { LedgersList, loading: loading4, error: error4 } = useGetGlLedgersList();
  // const { PeriodsList, GlPeriods, loading: loading5, error: error5 } = useGetGlPeriodsList();

  // ✅ خيارات الـ Select (عدّل outputs حسب الهوكس عندك)
  // const { ledgerOptions } = useGetLedgersList(); // [{value,label}]
  // const { jeCategoryOptions } = useGetJeCategoriesList();
  // const { jeSourceOptions } = useGetJeSourcesList();
  // const { periodOptions } = useGetPeriodsList();
  // const { currencyOptions } = useLookupCurrency(); // غالبًا [{value:'SAR',label:'SAR'}]

  const { OptionsLedgers, loading: loadingLedgers, error: errorLedgers } = useGetGlLedgersList();
  const { OptionsJeCategory, loading: loadingJeCategory, error: errorJeCategory } = useGetGlJeCategoryList();
  const { OptionsJeSource, loading: loadingJeSource, error: errorJeSource } = useGetGlJeSourceList();
  const { OptionsGlPeriods, loading: loadingGlPeriods, error: errorGlPeriods } = useGetGlPeriodsList();

  // ✅ تهيئة الجدول
  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Finance/GetGlJeHeadersList_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  // ✅ حساب عدد الفلاتر النشطة
  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ✅ توليد ID فريد للفلتر
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // ✅ تنسيق المبالغ
  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount ?? 0);
  };

  // ✅ خيارات الحالة (عدّلها حسب الـ status الفعلي عندك)
  // مثال بياناتك: status = "U"
  const statusOptions = [
    { value: 'U', label: t('غير مرحّل') }, // Unposted
    { value: 'P', label: t('مرحّل') } // Posted
    // { value: 'R', label: t('معكوس') } // Reversed (إن وجد)
  ];

  const getStatusBadge = (status: string) => {
    const s = (status ?? '').toUpperCase();
    switch (s) {
      case 'P':
        return (
          <span className='badge bg-success' title={t('مرحّل')}>
            <i className='fas fa-check-circle me-1'></i>
            مرحّل
          </span>
        );
      case 'U':
        return (
          <span className='badge bg-warning text-dark' title={t('غير مرحّل')}>
            <i className='fas fa-clock me-1'></i>
            غير مرحّل
          </span>
        );
      case 'R':
        return (
          <span className='badge bg-danger' title={t('معكوس')}>
            <i className='fas fa-undo me-1'></i>
            معكوس
          </span>
        );
      default:
        return (
          <span className='badge bg-light text-dark' title={status || t('Unknown')}>
            <i className='fas fa-circle me-1'></i>
            {status || 'غير معروف'}
          </span>
        );
    }
  };

  const getRowClasses = (status: string) => {
    const s = (status ?? '').toUpperCase();
    if (s === 'U') return 'bg-warning bg-opacity-10';
    if (s === 'R') return 'bg-danger bg-opacity-10';
    return '';
  };

  // ✅ عرض رقم القيد + تاريخ GL في عمود واحد
  const renderCodeWithDate = (code: string, glDate: string) => {
    return (
      <div className='d-flex flex-column'>
        <div className='fw-bold text-theme' style={{ letterSpacing: '0.05em' }}>
          {code}
        </div>
        <small className='text-muted'>
          <i className='fas fa-calendar-alt me-1'></i>
          {glDate}
        </small>
      </div>
    );
  };

  // ✅ دمج (Ledger + Period) في عمود واحد
  const renderLedgerWithPeriod = (ledgerName: string, periodName: string) => {
    return (
      <div className='d-flex flex-column'>
        <div className='fw-bold'>
          <i className='fas fa-book me-1 text-muted'></i>
          {ledgerName || '-'}
        </div>
        <small className='text-muted mt-1'>
          <i className='fas fa-layer-group me-1'></i>
          {periodName || '-'}
        </small>
      </div>
    );
  };

  // ✅ دمج (Source + Category) في عمود واحد
  const renderSourceWithCategory = (sourceName: string, categoryName: string) => {
    return (
      <div className='d-flex flex-column'>
        <div className='fw-bold'>
          <i className='fas fa-stream me-1 text-muted'></i>
          {sourceName || '-'}
        </div>
        <small className='text-muted mt-1'>
          <i className='fas fa-tags me-1'></i>
          {categoryName || '-'}
        </small>
      </div>
    );
  };

  // ✅ دمج (Dr/Cr + Name) في عمود واحد
  const renderAmountsWithName = (dr: number, cr: number, name?: string) => {
    const n = (name ?? '').trim();
    return (
      <div className='d-flex flex-column'>
        <div className='d-flex gap-3 align-items-center'>
          <span className='fw-bold text-success' title='Debit'>
            <i className='fas fa-arrow-up me-1'></i>
            {formatAmount(dr)}
          </span>
          <span className='fw-bold text-danger' title='Credit'>
            <i className='fas fa-arrow-down me-1'></i>
            {formatAmount(cr)}
          </span>
        </div>
        {n && (
          <small className='text-muted mt-1' title={n}>
            <i className='fas fa-align-left me-1'></i>
            {n.length > 60 ? `${n.substring(0, 60)}...` : n}
          </small>
        )}
      </div>
    );
  };

  // ✅ تطبيق الفلاتر
  const applyFilters = () => {
    const newFilters: any[] = [];

    if (ledgerFilter) {
      newFilters.push({ id: generateFilterId(), field: 'ledgerId', operator: 0, value: ledgerFilter.value });
    }
    if (periodFilter) {
      newFilters.push({ id: generateFilterId(), field: 'periodId', operator: 0, value: periodFilter.value });
    }
    if (sourceFilter) {
      newFilters.push({ id: generateFilterId(), field: 'jeSource', operator: 0, value: sourceFilter.value });
    }
    if (categoryFilter) {
      newFilters.push({ id: generateFilterId(), field: 'jeCategory', operator: 0, value: categoryFilter.value });
    }
    if (statusFilter) {
      newFilters.push({ id: generateFilterId(), field: 'status', operator: 0, value: statusFilter.value });
    }
    if (currencyFilter) {
      newFilters.push({ id: generateFilterId(), field: 'currencyCode', operator: 0, value: currencyFilter.value });
    }
    if (dateFrom) {
      newFilters.push({ id: generateFilterId(), field: 'glDate', operator: 3, value: dateFrom }); // >=
    }
    if (dateTo) {
      newFilters.push({ id: generateFilterId(), field: 'glDate', operator: 5, value: dateTo }); // <=
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ مسح الفلاتر
  const clearFilters = () => {
    setLedgerFilter(null);
    setPeriodFilter(null);
    setSourceFilter(null);
    setCategoryFilter(null);
    setStatusFilter(null);
    setCurrencyFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ حقول DynamicFilter (عدّلها حسب الـ API)
  const fields: any = [
    { name: 'code', label: t('رقم القيد'), type: 'string' },
    { name: 'glDate', label: t('تاريخ القيد'), type: 'date' },
    { name: 'ledgerId', label: t('دفتر الأستاذ'), type: 'options', options: [] },
    { name: 'periodId', label: t('الفترة'), type: 'options', options: [] },
    { name: 'jeSource', label: t('المصدر'), type: 'options', options: [] },
    { name: 'jeCategory', label: t('التصنيف'), type: 'options', options: [] },
    { name: 'status', label: t('الحالة'), type: 'options', options: statusOptions },
    { name: 'currencyCode', label: t('العملة'), type: 'options', options: [] },
    { name: 'name', label: t('البيان'), type: 'string' },
    { name: 'accountedDr', label: t('مدين (محاسبي)'), type: 'number' },
    { name: 'accountedCr', label: t('دائن (محاسبي)'), type: 'number' }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('القيود اليومية'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('القيود اليومية')} />
        <div className='ms-auto'>
          {/* ✅ عدّل المسار حسب صفحة الإضافة عندك */}
          {/* <Link to='AddGlJeHeaders' className='btn btn-theme'> */}
          <Link to={`AddJournals`} className='btn btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('قيد جديد')}
          </Link>
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* Ledger */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-book'></i>
                </span>
                <Select
                  isLoading={loadingLedgers}
                  value={ledgerFilter}
                  onChange={setLedgerFilter}
                  options={OptionsLedgers}
                  placeholder={t('دفتر الأستاذ')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Period */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-layer-group'></i>
                </span>
                <Select
                  value={periodFilter}
                  onChange={setPeriodFilter}
                  options={OptionsGlPeriods}
                  isLoading={loadingGlPeriods}
                  placeholder={t('الفترة')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Source */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-stream'></i>
                </span>
                <Select
                  value={sourceFilter}
                  onChange={setSourceFilter}
                  options={OptionsJeSource}
                  isLoading={loadingJeSource}
                  placeholder={t('المصدر')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Category */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-tags'></i>
                </span>
                <Select
                  value={categoryFilter}
                  onChange={setCategoryFilter}
                  options={OptionsJeCategory}
                  isLoading={loadingJeCategory}
                  placeholder={t('التصنيف')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Status */}
            <div className='col-lg-2'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-info-circle'></i>
                </span>
                <Select
                  value={statusFilter}
                  onChange={setStatusFilter}
                  options={statusOptions}
                  placeholder={t('الحالة')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* Date From/To */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('من')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('إلى')}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className='col-lg-3 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={
                  !ledgerFilter &&
                  !periodFilter &&
                  !sourceFilter &&
                  !categoryFilter &&
                  !statusFilter &&
                  !currencyFilter &&
                  !dateFrom &&
                  !dateTo
                }
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>رقم القيد / التاريخ</th>
                  <th className='small'>الدفتر / الفترة</th>
                  <th className='small'>المصدر / التصنيف</th>
                  <th className='small'>مدين / دائن / البيان</th>
                  <th className='small text-center'>الحالة</th>
                  <th className='small text-center'>الإجراءات</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => {
                    const ledgerName = i18n.language === 'en' ? item.ledgerName : item.ledgerName2;
                    const periodName = i18n.language === 'en' ? item.periodName : item.periodName2;
                    const sourceName = i18n.language === 'en' ? item.jeSourceName : item.jeSourceName2;
                    const categoryName = i18n.language === 'en' ? item.jeCategoryName : item.jeCategoryName2;
                    const note = i18n.language === 'en' ? item.name : item.name2;

                    return (
                      <tr key={item.id} className={getRowClasses(item.status)}>
                        <td className='align-middle'>{renderCodeWithDate(item.code, item.glDate)}</td>
                        <td className='align-middle'>{renderLedgerWithPeriod(ledgerName, periodName)}</td>
                        <td className='align-middle'>{renderSourceWithCategory(sourceName, categoryName)}</td>
                        <td className='align-middle'>
                          {renderAmountsWithName(item.accountedDr, item.accountedCr, note)}
                        </td>
                        <td className='align-middle text-center'>{getStatusBadge(item.status)}</td>
                        <td className='align-middle text-end'>
                          <div className='d-flex justify-content-end gap-2'>
                            {/* ✅ عدّل مسار التفاصيل حسب عندك */}
                            <Link
                              to={`${item.id}/UpdateJournals`}
                              className='btn btn-sm btn-outline-theme'
                              title={t('ViewDetails')}
                            >
                              <i className='bi bi-info-circle fa-lg me-1'></i>
                              تفاصيل
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center py-5 text-muted'>
                      <div className='py-4'>
                        <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
                        <h5 className='mb-2'>
                          {activeFiltersCount > 0 ? t('NoSearchResults') : t('لا توجد قيود مسجلة')}
                        </h5>
                        <p className='text-muted small'>
                          {activeFiltersCount > 0 ? 'جرّب تغيير شروط البحث' : 'لم يتم العثور على قيود حتى الآن'}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />
    </>
  );
};

export default Index;
